import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../../providers/AuthContext";
import Loader from "../Loader/Loader";

interface AdminProtectedRouteProps {
  children: React.ReactElement;
}

const AdminProtectedRoute: React.FC<AdminProtectedRouteProps> = ({
  children,
}) => {
  const { isAuthenticated, loading, profile } = useAuth();

  if (loading) {
    return <Loader />;
  }

  if (!isAuthenticated) {
    return <Navigate to="/signin" replace />;
  }

  if (!profile) {
    return <Loader />;
  }

  const isAdmin = profile.role?.toLowerCase() === "admin";

  if (!isAdmin) {
    return <Navigate to="/404" replace />;
  }

  return children;
};

export default AdminProtectedRoute;
